import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_2 = { class: "mt-2.5" }
const _hoisted_3 = ["name", "id", "required", "placeholder"]
const _hoisted_4 = ["type", "name", "id", "required", "placeholder"]

import type { FormFieldProps } from "./FormFieldProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
    label: {},
    placeholder: {},
    inputName: {},
    isRequired: { type: Boolean },
    type: {},
    spanFull: { type: Boolean },
    labelColor: {},
    accentColor: {},
    borderColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "3fdd4d85": (_ctx.borderColor),
  "623080b2": (_ctx.accentColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.spanFull ? 'sm:col-span-2' : ''])
  }, [
    _createElementVNode("label", {
      class: "block text-sm/6 cursor-pointer",
      style: _normalizeStyle({ color: _ctx.labelColor })
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.isRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.type === 'textarea')
          ? (_openBlock(), _createElementBlock("textarea", {
              key: 0,
              name: _ctx.inputName,
              id: _ctx.inputName,
              required: _ctx.isRequired,
              placeholder: _ctx.placeholder,
              rows: "4",
              class: "block w-full rounded-lg bg-white px-3.5 py-2 text-gray-900 placeholder:text-gray-400 form-element"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("input", {
              key: 1,
              type: _ctx.type,
              name: _ctx.inputName,
              id: _ctx.inputName,
              required: _ctx.isRequired,
              placeholder: _ctx.placeholder,
              class: "block w-full rounded-lg bg-white px-3.5 py-2 text-gray-900 placeholder:text-gray-400 form-element"
            }, null, 8, _hoisted_4))
      ])
    ], 4)
  ], 2))
}
}

})